import React, { Component } from 'react';
import TinkerGrounds from './TinkerGrounds';

class Main extends Component {
  
  constructor() {
    super();

    this.exampleRef = React.createRef()
  }

  render() {

    let textureArray = [  [ ['posX.jpg', 'negX.jpg', 'posY.jpg', 'negY.jpg', 'posZ.jpg', 'negZ.jpg'], "environmentMap" ],
                          ["./look/diffuse.png", "diffuseMap"],     
                          ["./T_ChunkyIce_A_roughness.png", "roughnessMap"],     
                          ["./T_ChunkyIce_A_Normal.png", "normalMap"],   
                          ["./T_ChunkyIce_A_height.png", "metallicMap"], 
                          ["./T_ChunkyIce_A_ambientOcclusion.png", "aoMap"], 
                          ["./look/grass-diffuse.jpg", "grassDiffuse"],
                          ["./look/grass-alpha.jpg", "grassAlpha"],
                          ["./skybox/Equirectangular/heaven_2k5.png", "equirectGrassPark01"],  
                          ["./look/diffuse01.png", "diffuseMap"], 
                          ["./look/diffuse02.png", "diffuseMap"], 
                          ["./look/diffuse03.png", "diffuseMap"],  
                          ["./look/freehandLinesStrong.png", "cornerRayLines"], 
                          ["./look/lensflare0.png", "lensFlare0"], 
                          ["./look/lensflare2.png", "lensFlare1"],
                          ["./look/lensflare4.png", "lensFlare3"],  
                          ["./look/lensflare3.png", "lensFlare2"], 
                          ["./look/lensflare6.png", "dust"],      
                          ["./look/movie.png", "mainMovie"],  
                          ["./look/test.png", "mainTest"],                                       
                       ];
    
    return (
      <div>
        <TinkerGrounds ratioDivisor="0.8" weakDeviceRatioDivisor="0.9" textures={textureArray} />
      </div>
    );
  }
}

export default Main;
